var GOVUKFrontend = require("govuk-frontend");
GOVUKFrontend.initAll();

window.$ = window.jQuery = require("jquery");
require("select2");
